import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onSearch", "onChange", "onClearButtonClick", "defaultValue", "value", "id", "label"];
import { forwardRef, useEffect, useState } from 'react';
import Search from '@crehana/compass.icons.outline/Search';
import { createFormFieldId } from "../helpers/createFormFieldId";
import { InputField } from "../InputField";
import CleanIcon from "./components/CloseIcon";
import { jsx as _jsx } from "react/jsx-runtime";
export var SearchField = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onSearch = _ref.onSearch,
    onChange = _ref.onChange,
    onClearButtonClick = _ref.onClearButtonClick,
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    id = _ref.id,
    label = _ref.label,
    inputFieldProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(value || defaultValue || ''),
    _useState2 = _slicedToArray(_useState, 2),
    controlledValue = _useState2[0],
    setControlledValue = _useState2[1];
  var inputId = createFormFieldId({
    id: id,
    label: label
  });
  var handleChange = function handleChange(event) {
    if (onChange) onChange(event);
    if (onSearch) onSearch(event.target.value);
    setControlledValue(event.target.value);
  };
  var clearSearch = function clearSearch() {
    setControlledValue('');
    if (onClearButtonClick) onClearButtonClick();

    /**
     * If we don't set the value manually, the input reference won't be updated.
     * That could bring issues when using RHF or trying to get the value with the reference
     * the onSearch function will be called, and the value updated, but the current reference wouldn't be sync
     */
    var input = document.getElementById("".concat(inputId));
    if (!input) return;
    input.value = '';
    input.dispatchEvent(new Event('change', {
      bubbles: true
    }));
  };
  useEffect(function () {
    if (typeof value !== 'undefined') {
      setControlledValue(value);
    }
  }, [value]);
  return /*#__PURE__*/_jsx(InputField, _objectSpread({
    ref: ref,
    id: inputId,
    label: label,
    onChange: handleChange,
    value: controlledValue,
    leadingIcon: Search,
    trailingElement: controlledValue && !inputFieldProps.disabled ? /*#__PURE__*/_jsx(CleanIcon, {
      onClick: clearSearch
    }) : undefined
  }, inputFieldProps));
});
SearchField.displayName = 'SearchField';
export default SearchField;